export enum UserAppmarketSettings {
  AppUpdateNotification = 'APP_UPDATE_NOTIFICATION',
}
